import { TipoPagamento } from "@/components/vitrine/data/tipoPagamento"
import { IconBoleto } from "@/components/vitrine/icons/IconBoleto"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { priceFormatter } from "@/utils/formatter"

interface ValuesAreaProps {
    produto: Produto
    etapaOferta: number
    escondePrecoFuturo: boolean
    precoPrincipal: number
    exibeQuantidadeEstoque: boolean
}

export function ValuesArea({
    produto,
    etapaOferta,
    escondePrecoFuturo,
    precoPrincipal,
    exibeQuantidadeEstoque
}: Readonly<ValuesAreaProps>) {
    const quantidadeOferta = produto.vitrine_opcoes?.qtde_disponivel != null ? produto.vitrine_opcoes.qtde_disponivel - (produto.vitrine_opcoes.qtde_vendida ?? 0) : produto.qtde_estoque

    return (
        <div className="values-area">
            <div className="preco-compra">
                {(produto.valor_de > produto.valor) && (
                    <div className="price-old">
                        <span>{priceFormatter.format(produto.valor_de)}</span>
                    </div>
                )}

                <div className="valor-venda-atual">
                    <div className="type-payment">
                        {(etapaOferta === 1 && escondePrecoFuturo) ? (
                            <div className="price-big">Aguarde pela oferta!!!</div>
                        ) : precoPrincipal === TipoPagamento.CARTAO ? (
                            <>
                                <div className="price-big">{priceFormatter.format(produto.valor)}</div>

                                {produto.valor_cartao && (
                                    <div className="condicacao-pagto">
                                        no cartão em {produto.valor_cartao[0]}x de {priceFormatter.format(produto.valor_cartao[2])}
                                    </div>
                                )}
                            </>
                        ) : (precoPrincipal === TipoPagamento.PIX && produto.valor_pix > 0) ? (
                            <>
                                <div className="price-big">{priceFormatter.format(produto.valor_pix)}</div>
                                <div className="condicacao-pagto">no pix com desconto</div>
                            </>
                        ) : (produto.valor_boleto > 0) ? (
                            <>
                                <div className="icon icon-boleto"><IconBoleto /></div>
                                <div className="price-big">{priceFormatter.format(produto.valor_boleto)}</div>
                                <div className="condicacao-pagto">no boleto bancário com desconto</div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>

            {(Boolean(exibeQuantidadeEstoque) && produto.qtde_estoque > 0) && (
                <div className="quantidade-oferta">
                    <div className="oferta-restante">
                        <div className="quantidade">{quantidadeOferta}</div>

                        <div className="quantidade-desc">
                            Quantidade <span>em oferta</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
